var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'canvas-filter',
    {
      maskRight:
        _vm.slideAmount > 1 &&
        _vm.selectedChipIndex === 0 &&
        _vm.selectedChipIndex < _vm.slideAmount - 1
    },
    {
      maskLeftRight:
        _vm.slideAmount > 1 &&
        _vm.selectedChipIndex > 0 &&
        _vm.selectedChipIndex < _vm.slideAmount - 1
    },
    ,
    {
      maskLeft:
        _vm.slideAmount > 1 &&
        _vm.selectedChipIndex > 0 &&
        _vm.selectedChipIndex === _vm.slideAmount - 1
    }
  ]},[_c('img',{staticClass:"arrow-left",attrs:{"src":(_vm.baseUrl + "assets/images/atoms-icons-actions-navigation-arrow-left.svg"),"alt":"arrow left"},on:{"click":function($event){_vm.selectedChipIndex = _vm.selectedChipIndex - 1}}}),_c('div',{class:['canvas-filter-wrapper']},[_c('TvaSlider',{key:_vm.getCountry,style:({ transform: 'translateY(20px)' }),attrs:{"config":{
        arrows: false,
        dots: false,
        options: {
          draggable: '>1',
          prevNextButtons: false,
          pageDots: false,
          imagesLoaded: true,
          lazyLoad: 2,
          adaptiveHeight: true,
          fade: false,
          groupCells: true
        }
      },"sliderGoTo":_vm.selectedChipIndex},on:{"click":_vm.click,"change":function($event){_vm.selectedChipIndex = $event},"setSlideAmount":function($event){_vm.slideAmount = $event}}},_vm._l((_vm.museums),function(museum,museumIndex){return _c('div',{key:museumIndex,staticClass:"museum",attrs:{"data-museum":museum[0].museum,"data-museumid":museum[0].museumId}},[(museum[0].id === _vm.cities[museum[0].city][0].id)?_c('div',{staticClass:"city"},[_vm._v("\n          "+_vm._s(museum[0].city)+"\n        ")]):_vm._e(),_c('div',{class:[
            'chip',
            {
              selected: _vm.getMuseum === museum[0].museum,
              unselected: _vm.getMuseum !== null
            }
          ],attrs:{"title":museum[0].museum}},[_c('span',{staticClass:"chip-label"},[_vm._v(_vm._s(museum[0].museum))]),_c('span',{staticClass:"chip-value"},[_vm._v(_vm._s(museum.length))])])])}),0)],1),_c('img',{staticClass:"arrow-right",attrs:{"src":(_vm.baseUrl + "assets/images/atoms-icons-actions-navigation-arrow-right.svg"),"alt":"arrow right"},on:{"click":function($event){_vm.selectedChipIndex = _vm.selectedChipIndex + 1}}})])}
var staticRenderFns = []

export { render, staticRenderFns }